// AGC: Due date selector — quick buttons (Hoje/Amanhã) + date input
import React from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import type { VoiceFieldProps } from './types'

export const DateField: React.FC<VoiceFieldProps> = ({
  info,
  inputValues,
  setInputValues,
  lastResponse,
  wizardMode,
}) => {
  const { t } = useTranslation()

  // AGC: Sizing classes — bigger in wizard mode to fill the full-screen card layout
  const sz = wizardMode
    ? { card: 'p-5', label: 'text-base', btn: 'px-4 py-3.5 text-base', input: 'px-4 py-3 text-base', gap: 'gap-2.5' }
    : { card: 'p-2', label: 'text-xs', btn: 'px-2 py-1.5 text-xs', input: 'px-2 py-1.5 text-xs', gap: 'gap-1.5' }

  return (
    <div className={`${sz.card} bg-white/5 border border-white/20 rounded-xl`}>
      <div className="mb-3">
        <span className={`text-white/80 ${sz.label} font-medium flex items-center gap-1`}>
          📅 {info.fieldLabel || t('voice.date')}
        </span>
      </div>
      <div className={`flex flex-wrap ${sz.gap} mb-2`}>
        {info.suggestions?.map((s: { value: string; label: string }) => (
          <button
            key={s.value}
            onClick={() => setInputValues(prev => ({ ...prev, dueDate: s.value }))}
            className={`${sz.btn} rounded border transition-colors ${
              (inputValues.dueDate || lastResponse?.parsedData?.dueDate) === s.value
                ? 'bg-emerald-500/30 border-emerald-500/50 text-emerald-300 font-medium'
                : 'bg-white/5 border-white/20 text-white/80 hover:bg-white/10'
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>
      <input
        type="date"
        value={(inputValues.dueDate || lastResponse?.parsedData?.dueDate || '').toString().slice(0, 10)}
        onChange={(e) => setInputValues(prev => ({ ...prev, dueDate: e.target.value }))}
        className={`w-full ${sz.input} bg-white/10 border border-white/20 rounded text-white placeholder-white/30 focus:outline-none focus:border-emerald-500 [color-scheme:dark]`}
      />
    </div>
  )
}
